import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    height: {
        id: "tasks.melodyTable.height",
    },
    position: {
        id: "tasks.melodyTable.position",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    method: {
        id: "score.upperText",
    },
    empty: {
        id: "score.upperText.empty",
    },
    solfa: {
        id: "score.upperText.solfa",
    },
    abc: {
        id: "score.upperText.abc",
    },
    handsign: {
        id: "score.settings.notehead.options.handsign"
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
    tonesetStaffNoKeyChange: {
        id: "tonesetStaff.noKeychange",
    },
});

export default messages;